import { Component, OnInit } from '@angular/core';
import { MatToolbarModule, MatSelectModule, MatFormFieldModule, MatButtonModule } from '@angular/material/';
import { HelperService } from './service/helper/helper.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
	title = 'WalletApp';
	constructor(public helper: HelperService) { }
	//0x26511e10c7a5677b60e6711421686239e011e909a927503a3af837c1baf51b76
	//0x311f51e029a1525b8e0f76d8dd9edaf82be818ad
	public show:boolean = false;
  public buttonName:any = 'Show';
	ngOnInit() {
		if(!window.localStorage.getItem('wallet_info')){
			window.localStorage.setItem('wallet_info',JSON.stringify(this.helper.walletInfo) )
		}
	}

	toggle() {
		this.show = !this.show;

		// CHANGE THE NAME OF THE BUTTON.
		if(this.show)
		  this.buttonName = "Hide";
		else
		  this.buttonName = "Show";
	  }
}

